/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlAnswerRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlAnswerRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlAnswerRequest>): ComplianceAssessmentControlAnswerRequest {
        let obj = Object.assign(new ComplianceAssessmentControlAnswerRequest(), model);
        ComplianceAssessmentControlAnswerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlAnswerRequest>): ComplianceAssessmentControlAnswerRequest {
        if (!model) return null;
        return ComplianceAssessmentControlAnswerRequest.newInstance(<ComplianceAssessmentControlAnswerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlAnswerRequest) {
        if (!obj) return;

        models.ComplianceAssessmentControlAnswerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlAnswerRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlAnswerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment Control status
     */
    assessment_control_status: models.ComplianceControlStatus;

    /**
     * Comment for the control
     */
    comment: string;

    /**
     * Attachment IDs for the control evidence
     */
    attachment_ids: Array<string>;

}
